import React, { ReactElement } from 'react';

import { TBadgeProperties } from './badge.types';
import { StyledBadge } from './badge.styled';

export function Badge({
    count,
    badgeType = 'default',
    color = 'pink',
    alignment = 'middle',
}: TBadgeProperties): ReactElement | null {
    if (count <= 0) return null;

    return (
        <StyledBadge badgeType={badgeType} color={color} alignment={alignment}>
            {count > 99 ? '99+' : count}
        </StyledBadge>
    );
}
